import React, {useState} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { List } from 'antd-mobile';
import Grade from '../../../../../grades';
import { getNickname, me, isSpectator, isLiveScorer, extract, isLiveInProgress, getOwnLiveSpectator, getUserProfile } from '../../../../../../helpers';
import { API_HOST } from '../../../../../../config.env';
import { subscribeLive } from '../../../../../../actions/matchDataActions';
import PropTypes from 'prop-types';
import { addBatchCustomData } from '../../../../../../services/notifications';
import './ListLive.css';
import InformationModal from '../../../../../modals/information/InformationModal';

const ListLive = props => {
    const access = props.connexionReducer;
    const [show, setShow] = useState(false);
    const [contentDialog, setContentDialog] = useState('');

        return (
            <List className='ls_listlive_home' 
                renderHeader={() => {
                    if (props.page === 'upcomingMatch') {
                        if (props.lives && props.lives.length <= 0) {
                            return (
                                <div style={{color: '#828286', fontFamily: 'fff-equipe', textAlign: 'justify'}}>
                                    <div style={{fontSize: '13px', fontWeight: '700'}}>Aucun Live Scorer disponible pour ce match</div>
                                    <div style={{fontSize: '11px'}}>Tu es intéressé pour commenter ce match en direct ?</div>
                                </div>
                            );
                        } else {
                            return (
                                <div className='common' style={{fontWeight: '700', textAlign: 'left'}}>
                                    {`Live Scorer disponible${props.lives && props.lives.length > 1 ? 's' : ''} pour ce match`}
                                </div>
                            )
                        }
                    } else {
                        if (props.lives && props.lives.length <= 0) {
                            return (
                                <div style={{color: '#828286', fontFamily: 'fff-equipe', textAlign: 'justify', fontSize: '11px'}}>
                                    Aucun Live Scorer n'a été disponible pour ce match
                                </div>
                            );
                        } else {
                            return <div className='common' style={{fontWeight: '700', textAlign: 'left'}}>Ils ont commenté ce match en live</div>
                        }
                    }
                }}>
                {renderListItem(props, access, {setShow, setContentDialog})}
                <InformationModal show={show} onCancel={() => setShow(false)} content={contentDialog}  />
            </List>
        )
    
}

const profileName = (lastname,firstname, nickname) => lastname && firstname ? getUserProfile(firstname, lastname, nickname) : 'LS';

const renderListItem = (props, access, hooks) => {
    if(props.lives && props.lives.length > 0) {
        return _.map(props.lives, l => {
            const id = l.id || extract(l['@id'],'/',3);
            return (
                <List.Item
                    key={id}
                    thumb={<div style={{width: '47px', height: '47px', paddingTop: '15px', paddingLeft: '9px'}} 
                    className='thumb-profile'>{profileName(l.author.lastname, l.author.firstname, l.author.nickname)}</div>}
                    arrow={`${( (props.isSpectator && isSpectator([l])) || props.page === 'pastMatch' || !props.isSpectator ) ? 'horizontal' : 'empty' }`}
                    extra={(props.page === 'pastMatch' || isLiveInProgress(l)) ? <span className='common' style={{fontWeight: '700'}}>{`${l.score.home || 0}:${l.score.away || 0}`}</span> : ''}
                    onClick={()=>subscribe(props,l,access, hooks)}
                    style={{opacity: ( (props.isSpectator && isSpectator([l])) || props.page === 'pastMatch' || !props.isSpectator ) ? 1 : 0.2}}
                >
                    <span className='common'>
                        {getNickname(l.author.firstname, l.author.lastname, l.author.nickname)} 
                        <List.Item.Brief>
                            <Grade page={props.page} live={l} access={access} />
                        </List.Item.Brief>
                    </span>
                </List.Item>
            )
        })
    }
}

const subscribe = (props,live,access, hooks) => {
    const id = live.id || extract(live['@id'],'/',3);
    switch(props.page) {
        case 'upcomingMatch':
                if(props.isSpectator) {
                    if(isSpectator([live])) {
                        props.history.push(`/live/${id}`);
                    }
                    else {
                        const ownLive = getOwnLiveSpectator(props.lives)
                        hooks.setShow(true);
                        hooks.setContentDialog(`Tu dois d'abord te désabonner du Live de ${ownLive.author.nickname} pour suivre un autre Live Scorer !`)
                    }
                }
                else {
                    if(!isLiveScorer([live])) {
                        axios.post(`${API_HOST}/api/users/${me().id}/subscribe`, {subscribe: [`/api/lives/${id}`]},{
                            headers: {
                                Accept: 'application/ld+json',
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${access}`
                            }
                        }).then(()=> {
                            //add tag batch recipient
                            setTimeout(() => {
                                addBatchCustomData({"ut.recipient": { "$add": [`live_${id}`]}})
                            }, 3000)

                            props.subscribeLive(id);
                            sessionStorage.setItem('followers', 1);
                            props.history.push(`/live/${id}`);
                        });
                    }
                }
        break;
        default: props.history.push(`/live/${id}`);
    }
}

const mapStateToProps = ({connexionReducer}) => ({connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({subscribeLive}, dispatch);

ListLive.propTypes = {
    isSpectator: PropTypes.bool.isRequired,
    page: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    subscribeLive: PropTypes.func.isRequired,
    lives: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        author: PropTypes.object,
        score: PropTypes.shape({home: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), away: PropTypes.oneOfType([PropTypes.number, PropTypes.string])})
    })).isRequired
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ListLive));
